import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { getUserPersonalData } from '../redux/actions';
import { LocationData } from '@shared/interfaces/LocationData';
import { userDataSelector } from '../redux/selectors';
import { setUserProfileDataLoading } from '../../UserProfilePage/redux';

export const useUserData = (): {
  userData: ReturnType<typeof userDataSelector>;
  fromLocation: LocationData | null;
  userId?: string;
} => {
  const [fromLocation, setFromLocation] = useState(null);
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const userData = useSelector(userDataSelector);

  useEffect(() => {
    setFromLocation(location?.state);
  }, []);

  useEffect(() => {
    if (!id) {
      return;
    }

    dispatch(getUserPersonalData(id));

    return () => {
      dispatch(setUserProfileDataLoading());
    };
  }, [id]);

  return {
    userId: id,
    userData,
    fromLocation,
  };
};
